// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"UserLimited_modal_title_fxk7t","wrap":"UserLimited_wrap_1kQiB","btn":"UserLimited_btn_Ndoar","signin":"UserLimited_signin_1MPn9","login":"UserLimited_login_5ncv7"};